// extracted by mini-css-extract-plugin
export default {"list":"categories_list__Ea5dw","listElement":"categories_listElement__1YJPu","active":"categories_active__oh1oN"};